export default __webpack_public_path__ + "68f52930402358d23160fd4f1fb331ea.svg";